import React from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import { calculateRoutes } from "commons/components/layout/LayoutBase";

import { RoutesType } from "commons/types/route";
import { SitemapType } from "commons/types/sitemap";

import PlatformLayout from "components/layout/PlatformLayout";
import PlatformContextsContainer from "components/layout/routes/PlatformContextsContainer";
import PrivateRoute from "components/layout/routes/PrivateRoute";

import { useConfigContext } from "context/config";

import AuthLogin from "pages/auth/Login";
import AuthLogout from "pages/auth/Logout";
import ErrorApi from "pages/error/ErrorApi";
import ErrorGeneric from "pages/error/ErrorGeneric";
import ErrorPageNotFound from "pages/error/ErrorPageNotFound";
import ErrorUnauthorized from "pages/error/ErrorUnauthorized";
import Root from "pages/Root";

import { getSitemap } from "sitemap";

function RoutesContainer() {
    const config = useConfigContext();

    const sitemap: SitemapType = React.useMemo(() => getSitemap(config), [config]);

    const routes: RoutesType = React.useMemo(() => {
        return calculateRoutes(sitemap);
    }, [sitemap]);

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route path={"/error/api"} element={<ErrorApi />} />
                <Route path={"/error/generic"} element={<ErrorGeneric />} />
                <Route path={"/error/unauthorized"} element={<ErrorUnauthorized />} />
                <Route path={"/error/unauthorized-user"} element={<ErrorUnauthorized logout />} />

                <Route element={<PlatformContextsContainer />}>
                    <Route path={"/"} element={<Root />} />

                    <Route path={"/auth/login"} element={<AuthLogin />} />
                    <Route path={"/auth/logout"} element={<AuthLogout />} />

                    <Route element={<PlatformLayout sitemap={sitemap} />}>
                        {routes.map((route) => (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={<PrivateRoute route={route} />}
                            />
                        ))}
                    </Route>
                </Route>

                <Route path={"*"} element={<ErrorPageNotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

export default RoutesContainer;
